import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { getUserDatabase } from './getUserDatabase';

export async function deleteFoodItemFromDatabase(user, containerKey, itemId) {
  if (!user?.uid || !containerKey || !itemId) {
    return null;
  }

  const userDatabase = await getUserDatabase(user);
  const containers = userDatabase?.containers ?? {};
  const containerItems = Array.isArray(containers[containerKey])
    ? containers[containerKey]
    : [];

  const nextDatabase = {
    ...userDatabase,
    containers: {
      ...containers,
      [containerKey]: containerItems.filter((item) => item.id !== itemId),
    },
  };

  await setDoc(doc(db, 'users', user.uid), nextDatabase, { merge: true });

  return nextDatabase;
}
